import React, { useEffect, createElement } from 'react';
// Define a type for the AddToCart event parameters
type AddToCartEventParams = {
  value?: number;
  currency?: string;
  content_name?: string;
  content_ids?: string[];
  content_type?: string;
};
// Create a global function to track events
export const trackPixelEvent = (eventName: string, params?: AddToCartEventParams) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', eventName, params);
  }
};
export function MetaPixel() {
  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') return;
    // Check if fbq already exists
    if ((window as any).fbq) return;
    // Wait for DOM to be ready
    const initPixel = () => {
      // Create Facebook Pixel script
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // Check if script element exists before inserting
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          // Fallback: append to head if no script tags exist
          document.head.appendChild(t);
        }
      }(window as any, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1090496406562570');
      (window as any).fbq('track', 'PageView');
    };
    // Initialize immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPixel);
    } else {
      initPixel();
    }
    // Cleanup function
    return () => {
      if (document.readyState === 'loading') {
        document.removeEventListener('DOMContentLoaded', initPixel);
      }
    };
  }, []);
  return <>
      {/* Noscript fallback for Meta Pixel */}
      <noscript data-id="element-266">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1090496406562570&ev=PageView&noscript=1" alt="" data-id="element-267" />
      </noscript>
    </>;
}